import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const changeReservationDate = (
  name: string,
  e: Date | number,
  formName,
): IChangeReservationDate => ({
  formName,
  name,
  type: ReservationModalActions.ChangeDate,
  value: e,
})

export interface IChangeReservationDate
  extends Action<ReservationModalActions.ChangeDate> {
  name: string
  formName: string
  value: Date | number
}

export { changeReservationDate }
